import { useNavigate } from "react-router-dom";
import { X, Minus, Plus, Trash2, ShoppingBag, Pill, Sparkles } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

const fmt = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export default function CartDrawer() {
  const { items, setQty, remove, subtotal, open, setOpen, hasRx } = useCart();
  const { user } = useAuth();
  const nav = useNavigate();

  if (!open) return null;

  const goCheckout = () => {
    setOpen(false);
    if (!user) {
      const next = encodeURIComponent("/b2b/checkout");
      nav(`/patient?next=${next}`);
      return;
    }
    if (!["patient", "doctor"].includes(user.role)) {
      nav("/patient");
      return;
    }
    nav("/b2b/checkout");
  };

  return (
    <div className="cart-overlay" onClick={() => setOpen(false)} data-testid="cart-overlay">
      <aside className="cart-drawer" onClick={(e) => e.stopPropagation()} data-testid="cart-drawer">
        <header>
          <h3><ShoppingBag size={17} /> Your cart <small>({items.length})</small></h3>
          <button onClick={() => setOpen(false)} className="cart-x" data-testid="cart-close"><X size={18} /></button>
        </header>

        {items.length === 0 ? (
          <div className="cart-empty">
            <ShoppingBag size={36} />
            <p>Your cart is empty.</p>
            <button className="pg-btn pg-btn-ghost" onClick={() => { setOpen(false); nav("/pharmaceuticals"); }}>Shop Pharmacy</button>
            <button className="pg-btn pg-btn-ghost" onClick={() => { setOpen(false); nav("/nutraceuticals"); }}>Shop Nutraceuticals</button>
          </div>
        ) : (
          <>
            <div className="cart-body" data-testid="cart-items">
              {items.map((it) => {
                const Ic = it.kind === "pharmaceutical" ? Pill : Sparkles;
                return (
                  <div key={it.product_id} className="cart-item" data-testid={`cart-item-${it.product_id}`}>
                    <div className="cart-thumb">
                      {it.image_url ? <img src={it.image_url} alt={it.name} /> : <Ic size={22} />}
                    </div>
                    <div className="cart-meta">
                      <b>{it.name}</b>
                      {it.partner_name && <small>{it.partner_name}</small>}
                      <div className="cart-row">
                        <div className="cart-qty">
                          <button onClick={() => setQty(it.product_id, it.qty - 1)} aria-label="decrease"><Minus size={12} /></button>
                          <span data-testid={`cart-qty-${it.product_id}`}>{it.qty}</span>
                          <button onClick={() => setQty(it.product_id, it.qty + 1)} aria-label="increase"><Plus size={12} /></button>
                        </div>
                        <button className="cart-rm" onClick={() => remove(it.product_id)} data-testid={`cart-rm-${it.product_id}`}><Trash2 size={13} /></button>
                      </div>
                      {it.rx_required && <small className="cart-rx">Rx required at checkout</small>}
                    </div>
                    <div className="cart-line">{fmt(it.price * it.qty)}</div>
                  </div>
                );
              })}
            </div>
            <footer>
              <div className="cart-totals">
                <span>Subtotal</span><b data-testid="cart-subtotal">{fmt(subtotal)}</b>
              </div>
              {hasRx && <p className="cart-hint">Rx items need an in-platform prescription (≤ 30 days). You'll attach one on the checkout page.</p>}
              <button className="pg-btn pg-btn-ink full" onClick={goCheckout} data-testid="cart-checkout">
                Proceed to checkout
              </button>
            </footer>
          </>
        )}
      </aside>
    </div>
  );
}
